import { render, staticRenderFns } from "./ClientCreditFlag.vue?vue&type=template&id=410969b3&scoped=true&"
import script from "./ClientCreditFlag.vue?vue&type=script&lang=js&"
export * from "./ClientCreditFlag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410969b3",
  null
  
)

export default component.exports